var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOne(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 44,
    viewBox: "0 0 40 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.75 16.5V31.625H13.75V4.125H22.5V11.6875C22.5 14.344 24.46 16.5 26.875 16.5H33.75ZM26.25 4.45775L33.4475 12.375H26.875C26.7092 12.375 26.5503 12.3026 26.4331 12.1736C26.3158 12.0447 26.25 11.8698 26.25 11.6875V4.45775ZM12.5 0C11.837 0 11.2011 0.289731 10.7322 0.805456C10.2634 1.32118 10 2.02065 10 2.75V8.25H5.625C3.9 8.25 2.5 9.79 2.5 11.6875V40.5625C2.5 42.46 3.9 44 5.625 44H26.25C27.975 44 29.375 42.46 29.375 40.5625V35.97L29.365 35.75H35C35.663 35.75 36.2989 35.4603 36.7678 34.9445C37.2366 34.4288 37.5 33.7293 37.5 33V12.1385C37.4999 11.4092 37.2364 10.7099 36.7675 10.1943L28.2325 0.80575C27.7638 0.289989 27.128 0.000155753 26.465 0H12.5ZM10 33V12.375H6.25V39.875H25.625V35.97C25.625 35.8967 25.6283 35.8233 25.635 35.75H12.5C11.837 35.75 11.2011 35.4603 10.7322 34.9445C10.2634 34.4288 10 33.7293 10 33Z",
    fill: "#4771FC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOne);
export default __webpack_public_path__ + "static/media/one.d349191f555a2d9c88e62d3c3f043c80.svg";
export { ForwardRef as ReactComponent };